export default __webpack_public_path__ + "static/media/fallout-mutation-stone.39b9311a.png";